const DB_NAME = "coach-dashboard-db";
const DB_VERSION = 1;
const STORE = "institutionSessions";

function openDb() {
  return new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_NAME, DB_VERSION);
    req.onerror = () => reject(req.error);
    req.onsuccess = () => resolve(req.result);
    req.onupgradeneeded = (event) => {
      const db = event.target.result;
      if (!db.objectStoreNames.contains(STORE)) {
        db.createObjectStore(STORE, { keyPath: "institutionId" });
      }
    };
  });
}

/**
 * @returns {Promise<{ institutionId: string, sessions: any[], meta: { lastFetchedPage: number, totalDocuments: number, totalPages: number, pageSize: number } } | null>}
 */
export async function getCachedInstitutionData(institutionId) {
  if (!institutionId || typeof indexedDB === "undefined") {
    return null;
  }
  try {
    const db = await openDb();
    return await new Promise((resolve, reject) => {
      const tx = db.transaction(STORE, "readonly");
      const store = tx.objectStore(STORE);
      const r = store.get(institutionId);
      r.onsuccess = () => resolve(r.result || null);
      r.onerror = () => reject(r.error);
    });
  } catch (e) {
    console.warn("IndexedDB read failed:", e);
    return null;
  }
}

export async function saveCachedInstitutionData(institutionId, sessions, meta) {
  if (!institutionId || typeof indexedDB === "undefined") {
    return;
  }
  try {
    const db = await openDb();
    await new Promise((resolve, reject) => {
      const tx = db.transaction(STORE, "readwrite");
      tx.oncomplete = () => resolve();
      tx.onerror = () => reject(tx.error);
      tx.objectStore(STORE).put({
        institutionId,
        sessions: sessions || [],
        meta: meta || null,
      });
    });
  } catch (e) {
    console.warn("IndexedDB write failed:", e);
  }
}

export async function clearCachedInstitutionData(institutionId) {
  if (!institutionId || typeof indexedDB === "undefined") {
    return;
  }
  try {
    const db = await openDb();
    await new Promise((resolve, reject) => {
      const tx = db.transaction(STORE, "readwrite");
      tx.oncomplete = () => resolve();
      tx.onerror = () => reject(tx.error);
      tx.objectStore(STORE).delete(institutionId);
    });
  } catch (e) {
    console.warn("IndexedDB delete failed:", e);
  }
}
